import React from 'react';
import { Col, Row, CardFooter } from 'reactstrap';

/**
 * Display updates in the card
 * @param {[integer]} number [description]
 */
const CardUpdates = ({ number }) => {
	if (typeof number === 'undefined' || number <= 0 || number > 99) {
		return (
			<CardFooter
				className="px-3 py-2 text-center d-flex justify-content-center updateFooter"
				style={{ ...updateFooter, border: 'none', background: '#F6F6F6' }}
			>
					<p className="align-self-center m-0 small-text update-read-more"> + Read More </p>
				<style jsx>{`
					.update-read-more {
						font-weight: 700;
						color: #ff5050;
					}
				`}
				</style>
			</CardFooter>
		);
	}
	return (
		<CardFooter className="px-3 py-2" style={updateFooter}>
			<Row>
				<Col xs="3" className="p-0">
					<div className="updateWrapper d-flex justify-content-center">
						<span className="m-0 align-self-center updateNumber">
							{number}
						</span>
					</div>
				</Col>
				<Col xs="9" className="d-flex justify-content-start pl-0">
					<p className="m-0 align-self-center small-text">
						There {number === 1 || number === '1' ? 'is 1 update' : `are ${number} updates `} for this beneficiary
					</p>
				</Col>
				<style jsx>{`
					.updateWrapper {
						padding: 0.5rem;
						border-radius: 50%;
						background: white;
						border: 2px solid #ff5050;
						height: 50px;
						width: 50px;
						text-align: center;
					}
					.updateNumber {
						line-height: 0;
				    font-size: 1.25rem;
				    color: #ff5050;
				    font-weight: 700;
					}
				`}
				</style>
			</Row>
		</CardFooter>
	);
};

const updateFooter = {
	background: 'white',
};

export default CardUpdates;
